import {
  instance,
  multipartJwtToken,
  setJwtToken,
} from "../../config/axiosInstance";

// Fetching SubAdmin List Api
export const subAdminListController = async (page, filterByStatus = null, limit, search,filterByRole) => {
  const params = {};
  params.page = page || "";
  params.status = filterByStatus || "";
  params.limit = limit || "";
  params.search = search || "";
  params.role = filterByRole || "";
  const data = await instance.get(`admin/subadmin-list`, {
    params,
    ...setJwtToken(),
  });
  return data;
};

// Fetching Module List Api
export const subAdminModuleListController = async () => {
  
  const data = await instance.get(`admin/module-list`, setJwtToken());
  return data;
};

// Fetching roles
export const adminTypeListController = async (page,
  limit, search) => {
  const params = {};
  params.page = page || "";
//  params.status = filterByStatus || "";
  params.limit = limit || "";
  params.search = search || "";
  const data = await instance.get(`admin/role-list`, {
    params,
    ...setJwtToken(),
  });
  return data;
};

// Fetching active roles
export const activeRoleList = async (page,
  limit, search) => {
  const params = {};
  params.page = page || "";
//  params.status = filterByStatus || "";
  params.limit = limit || "";
  params.search = search || "";
  const data = await instance.get(`admin/active-roles`, {
    params,
    ...setJwtToken(),
  });
  return data;
};

// Fetching Access List Api
export const subAdminAccessListController = async () => {
  const data = await instance.get(`admin/access-list`, setJwtToken());
  return data;
};

// Add Sub-Admin
export const addSubAdminController = async (reqData) => {
  const data = await instance.post(
    `admin/create-subadmin`,
    reqData,
    setJwtToken()
  );
  return data;
};

// Create Admin
export const addRoleController = async (reqData) => {
  const data = await instance.post(
    `admin/create-role`,
    reqData,
    setJwtToken()
  );
  return data;
};

// View Sub-Admin
export const viewSubAdminController = async (id) => {
  const data = await instance.get(
    `admin/subadmin-detail?id=${id}`,
    setJwtToken()
  );
  return data;
};
export const viewRoleController = async (id) => {
  const data = await instance.get(
    `admin/role-detail?id=${id}`,
    setJwtToken()
  );
  return data;
};

// Edit Sub-Admin
export const editSubAdminController = async (reqData) => {
  const data = await instance.post(
    `admin/update-subadmin`,
    reqData,
    setJwtToken()
  );
  return data;
};

// Edit Sub-Admin
export const editRoleController = async (reqData) => {
  const data = await instance.post(
    `admin/update-role`,
    reqData,
    setJwtToken()
  );
  return data;
};

// Subadmin Status Change API
export  const changeStatusSubAdminController = async (subadminId) => {
  const data = await instance.post(
    `admin/update-sub-admin-status`,
    { id: subadminId },
    setJwtToken()
  );
  return data;
};
// Role Status Change API
export  const changeStatusRoleController = async (roleId) => {
  const data = await instance.post(
    `admin/update-role/status`,
    { id: roleId },
    setJwtToken()
  );
  return data;
};
